module.exports = __webpack_public_path__ + "static/media/AddRequestGrey.72c0d1be.svg";